/**
 Author - Muhamed Afsal
 Git - https://bitbucket.org/mohdafsal/
 **/

import React from "react";
import PropTypes from "prop-types";

import styled from "styled-components";
import {WealthyEnv} from "helpers";
import {colors} from "nxtconstants";
import {Spinner} from "components";


const propTypes = {
  closePopUp: PropTypes.func.isRequired,
  email: PropTypes.string.isRequired,
  isLoading: PropTypes.bool.isRequired,
  submitSubscribe: PropTypes.string.isRequired,
  subscribeInputHandler: PropTypes.string.isRequired,
  subscribeText: PropTypes.string
};

const SubscribeNewsletterPopUp = ({
  closePopUp,
  subscribeText,
  email,
  submitSubscribe,
  subscribeInputHandler,
  isLoading
}) => {
  const newsletterIcon = `${WealthyEnv.CDN_URL}/articles/subscribe-newsletter.png`;
  return (
    <Overlay>
      <PopupContainer id="subscribe-newsletter-popup">
        <Popup>
          <CoverImage src={newsletterIcon} />
          <Heading>
            Subscribe to our newsletter
          </Heading>
          <Text>
            {
              subscribeText || " Subscribe and Join a community of 90,000+ readers to stay in tune with markets"
            }
          </Text>
          <Form>
            <InputContainer>
              <Input
                name="email"
                placeholder="Enter email"
                type="email"
                value={email}
                onChange={subscribeInputHandler}
              />
              <SubmitButton
                id="subscribe-newsletter-popup--button"
                type="submit"
                onClick={submitSubscribe}
              >
                {isLoading ?
                  <Spinner
                    color="#fff"
                    size="2rem"
                  />
                  :
                  "Subscribe"}
              </SubmitButton>
            </InputContainer>
          </Form>
          <CloseButton onClick={closePopUp} />
        </Popup>
      </PopupContainer>
    </Overlay>
  );
};

const Overlay = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
`;

const PopupContainer = styled.section`
  width: 100%;
  text-align: center;
  overflow: hidden;
  display: flex;
  max-width: 1040px;
  justify-content: center;
  position: relative;
`;

const Popup = styled.div`
  position: relative;
  background: white;
  width: 50%;
  min-width: 300px;
  padding: 5rem;
  color: #464646;
  border-radius: 10px;

  @media (max-width: 48em) {
    width: 90%;
    padding: 5rem 3rem;
    max-width: 400px;
  }
`;

const Form = styled.form``;

const InputContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 3rem auto 0;
  width: 100%;
  flex-direction: column;
`;

const Input = styled.input`
  border: none;
  background: #f7f3f5;
  border-radius: 30px;
  width: 30rem;
  height: 4.5rem;
  padding: 0 2rem;
  font-size: 1.4rem;
  font-family: Avenir-Light;
  color: rgb(103, 37, 244);
  text-align: center;
  font-weight: 600;

  &::placeholder {
    color: rgb(106 99 122);
  }
`;

const SubmitButton = styled.button`
  display: inline-block;
  border-radius: 30px;
  border: 2px solid ${colors.primary};
  background: ${colors.primary};
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  font-size: 1.4rem;
  z-index: 1;
  width: 12rem;
  padding: 1rem;
  cursor: pointer;
  box-shadow: rgb(103 37 244 / 15%) 3px 7px 34px;
  margin-top: 2rem;
`;

const CoverImage = styled.img`
  width: 100%;
  max-width: 250px;
  margin-bottom: 2rem;
  max-height: 140px;
  width: 100px;
  max-height: 100%;
`;

const Heading = styled.h2`
  font-family: Avenir-Heavy;
  font-size: 2.6rem;
  line-height: 1.4;
  color: #666;
`;

const CloseButton = styled.span`
  position: absolute;
  top: 0;
  right: 0;
  width: 40px;
  height: 40px;
  background: transparent;
  border-radius: 50%;
  margin: 0.5rem;
  cursor: pointer;
  display: inline-block;

  &::before,
  &::after {
    content: "";
    margin-left: -12px;
    margin-top: -2px;
    left: 50%;
    top: 50%;
    width: 18px;
    height: 3px;
    background-color: #c3c9ec;
    position: absolute;
  }

  &::before {
    transform: rotate(45deg);
  }

  &::after {
    transform: rotate(-45deg);
  }
`;

const Text = styled.p`
  font-family: Avenir-Light;
  font-size: 1.6rem;
  margin: 0 auto 0;
  line-height: 1.5;
`;

SubscribeNewsletterPopUp.propTypes = propTypes;

export default SubscribeNewsletterPopUp;
